module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv2_logo_v2_1.8d4852659b5369fd6f90b877ff1f0b9b.png";